var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list',_vm._l((_vm.links),function(link,index){return _c('NavigationLink',{key:index,attrs:{"link":link}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }